class BannerSlider extends HTMLElement {
  // connect component
  connectedCallback() {
    const slider = this.querySelector('.swiper');
    if (!slider) return;

    const sliderId = slider.id;
    const slideCount = slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

    // Only initialize if there's more than one slide
    if (slideCount > 1) {
      new Swiper(`#${sliderId}`, {
        loop: true,
        speed: 600,
        pagination: {
          el: `#${sliderId} .swiper-pagination`,
          clickable: true
        },
        navigation: {
          nextEl: `#${sliderId} .swiper-button-next`,
          prevEl: `#${sliderId} .swiper-button-prev`
        }
      });
    }
  }
}

customElements.define("banner-slider", BannerSlider);
